import { TrueToSizeBlockUI } from "./TrueToSizeBlockUI";
import { StandardProps } from "../componentMap";

export function TrueToSizeBlock({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  const { reviewsApiKey, reviewsSubratingUrl } = runtimeConfig;

  return (
    <TrueToSizeBlockUI
      productId={product.aliases.pimProductId}
      reviewsApiKey={reviewsApiKey}
      reviewsSubratingScriptUrl={reviewsSubratingUrl}
    />
  );
}
